module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Get your long, spiny fingers off my arm, you heartless ignorant automaton,” Grandma Wrinkle snapped. She tried to pull herself free from her guard’s viselike grip, but her strength was no match for his. Even though her spirit was strong, Grandma Wrinkle’s physical strength at 987 years old was not what it had been when she was a young alien of 113.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Save your breath, old turtle,” the guard responded. He was at least seven feet tall with shoulders just as wide. “Where you’re going, no one is going to be able to hear you, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Squadron guards had been sent to Grandma Wrinkle’s prison pod to bring her to the Supreme Commander, but she was refusing to go. Unlike all the other citizens on her planet, Grandma Wrinkle had the courage to resist government orders. She had no use for her planet’s "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("repressive regime, and she was not afraid to say so. Even after all those weeks alone in her prison pod, she remained unafraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two male guards surrounded her, grabbing her by the arm while the one female guard held her by the scruff of her neck. Grandma Wrinkle planted her suction cup feet firmly on the metallic floor, hoping they would hold her in place, but she wasn’t as young as she used to be, and so all it took was one shove from the powerful female guard to break the suction and send Grandma Wrinkle hurtling out of her pod and into the long, white hall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you taking me?” Grandma Wrinkle asked. “As the former master mechanic of our spaceship fleet, I have the right to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t work for this planet’s government anymore,” the female guard growled in her raspy voice. “You’re our prisoner and you have no rights.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve done nothing wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You built a faster-than-light vehicle that your grandson, Citizen Short Nose, used to escape to Earth. The Supreme Commander has ordered that he be captured and returned to our planet immediately. He is a traitor and must be punished.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re all fools,” Grandma Wrinkle said, “blindly "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("following a brutal government. My grandson was about to have his sensory enhancer neutralized. Deactivated. They were going to take away his ability to experience the joys of life—music, art, film, stories, beauty. I couldn’t have him turned into a robot like you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On hearing those words, one of the male guards, who was missing two of his six eyes, stopped walking. A faraway look came over his four good eyes, as if he were remembering some distant and pleasant memory. It was the sound of his mother’s voice, soothing him to sleep in his baby pod. A warm feeling came over him, and he loosened his grip on Grandma Wrinkle’s arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The female guard, whose name, Citizen Cruel, had been given to her for obvious reasons, noticed the softening of her coworker’s face. She stared at him, her catlike eyes glowing golden with anger. Her gaze was so fierce that the guard had to hold his hand up to protect himself from her intense yellow glare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Citizen Four Eyes, do not listen to the words of this old woman,” she commanded. “She will lead you down the path of forbidden memories. If you can’t control your emotional weakness, I will disqualify you from entering the Body Snatcher Unit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, please don’t do that, Citizen Cruel,” the four-eyed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("guard begged. “I have been training to be a body snatcher my whole life, and my final assessment is very soon now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m on the selection panel, and I’ll be watching you,” Citizen Cruel said. “We Body Snatchers are an elite unit, and only the strongest and toughest are chosen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean, only the cruelest,” Grandma Wrinkle said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one asked you,” Citizen Cruel barked. “Keep your two tongues silent or I’ll tie them in a knot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The group marched in silence down the long, white hall, past porthole windows that let in shafts of rust-colored light from the red dwarf sun outside. Grandma Wrinkle tried to look through the windows to see where she was. She caught brief glimpses of broken-down mechanical parts—fragments of interstellar fighters and busted-up afterburners. She realized that she was in the Cemetery, an earthen pit that was the final resting place of obsolete vehicles, a place she knew well. It was where she had built her grandson’s escape vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eyes straight ahead, you mouthy pest,” Citizen Cruel ordered. “All six of them. Unless you want me to poke out a couple, so you’ll look like Four Eyes over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandma Wrinkle rotated all her eyeballs to the front of her head, and the group marched down the hall silently. The only sound was the echo of their suction cups bouncing off "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("the floor. Soon, they reached a dead end. Citizen Cruel took a deep breath and blew onto the blank wall in front of her.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I detect your breath, Citizen Cruel,” a mechanical voice said. “You may enter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Walk, turtle,” Citizen Cruel ordered, giving Grandma Wrinkle a hard shove.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Into the wall?” Grandma Wrinkle answered. “That’s stupid. But that’s what you people do . . . follow orders even if they make no sense.”")]), _vm._v(" "), _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("Citizen Cruel glared at Grandma Wrinkle, her yellow cat eyes squinting in anger. She grabbed Grandma Wrinkle and pushed. Just before the old woman slammed into the wall, it slid open, revealing a shining blue chasm.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get in,” Citizen Cruel commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve heard about this elevator.” Grandma Wrinkle showed no fear as she spoke, only defiance. “It has one destination—the Cavern of Questions. It’s useless to take me there. You’ll get no information from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I’m not worried. We have our special ways to persuade you to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean torture,” Grandma Wrinkle said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some people might call it that. We prefer to call it heightened persuasion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Citizen Cruel laughed. It was an ugly sound, like someone choking on a chicken bone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps Citizen Bulk can demonstrate his heightened powers of persuasion now,” she wheezed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Citizen Bulk pointed one of his seven fingers at Grandma Wrinkle and an electric current shot out, making a crackling sound. The old woman shuddered as the current ran down her spine and she tumbled into the elevator headfirst. She couldn’t speak, but if she could have, she would have said words that would get the average Earth kid grounded for at least six months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("The elevator shot down with such a strong g-force that everybody’s cheeks jiggled. The four-eyed guard turned a little green and grabbed his stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I may toss my nutritional wafers,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you want to qualify for the Body Snatcher Corps, you better toughen up right now,” Citizen Cruel warned. “If you can’t even hold your wafers down, what good are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The elevator plummeted deep down into the core of the planet, breaking through a crusty mantle and entering a liquid ocean that glowed red-hot. As they traveled deeper and deeper toward the planetary core, the red-hot glow turned to yellow-hot then finally to white-hot, making the temperature in the elevator shoot up to an almost unbearable degree. Everyone, from Grandma Wrinkle to all three guards, began to sweat from their cobalt-blue skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just when the heat inside seemed no longer tolerable, the elevator came to a screeching halt. The wall slid open, and there he was, the Supreme Leader, standing on a floating platform in the center of the Cavern of Questions. He was in his full military uniform, with laser swords hanging from his shiny spacesuit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What took you so long?” he shouted across the giant hall. “You were supposed to have her here seven minutes ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a talker, sir,” Citizen Cruel said. “She tried to resist. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("We had to use Citizen Bulk’s laser finger to subdue her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stand her up and drag her to me,” the Supreme Leader ordered. He was not someone who tolerated excuses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Citizen Cruel on one side and Citizen Bulk on the other, Grandma Wrinkle was brought before him. From his floating platform, the Supreme Leader looked down on her with his row of cold, hateful eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at me,” he ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandma Wrinkle did not look up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think the heat has overwhelmed her,” Citizen Four Eyes said. “After all, she is very old and her body is frail. My grandmother was frail too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Citizen Four Eyes seems to have a soft spot for this traitor,” Citizen Cruel said. “He is showing signs of weakness. I have warned him that compassion is unacceptable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Supreme Leader stepped off his platform and floated down to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not unkind, as many say,” he said to Citizen Four Eyes. “And to prove that, I will not have you banished. Instead, you are to be taken to the reeducation unit until I am assured that this small-minded emotional behavior has been drummed out of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, sir, he is about to be tested for the Body Snatching Corps,” Citizen Cruel said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("“That’s out of the question. I will reexamine my decision after his reeducation is complete.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Th-th-thank you for this opportunity, sir,” Citizen Four Eyes stammered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, shut up,” the Supreme Leader snapped. “Your courtesy makes me cringe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Citizen Four Eyes bowed and backed away, but he was so terrified that his weak stomach gave out, and he tossed his wafers onto the floor near the elevators. The Supreme Leader did not see this infraction, since he had already turned his full attention to Grandma Wrinkle. She stood facing him, motionless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speak to me,” he said. “We’ve known each other too long for this silence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I no longer know you, Citizen Clumsy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one is allowed to call me by my childhood name. I am the Supreme Leader now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And your power has made you evil.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Supreme Leader winced at her words. “Douse her with frigid air,” he commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My pleasure.” Citizen Cruel grinned. “She’s a stubborn old thing who showed no respect for my authority, and I can’t wait to teach her a lesson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They put Grandma Wrinkle in a titanium chair, strapped "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("her in, and lowered a glass cage over her. Citizen Cruel went to a control panel and flipped one of the hundreds of switches, and a burst of freezing air shot into the cage. Within seconds, the glass became obscured with frost, and Grandma Wrinkle was no longer visible. A minute later, when the glass cage was raised, Grandma Wrinkle was shivering, and her cobalt fingers had turned an even deeper shade of blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know why we have brought you here,” the Supreme Leader said. “You helped your grandson escape. No one leaves this planet without my permission. We cannot allow that. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, I understand,” Grandma Wrinkle said. “It’s not brain science. You’re a bully and you want everyone to do as you say. But some of us remember the way it was before you made yourself the Supreme Leader, when we were free. When there was joy and music and art and life here. I have sent my grandson off to Earth to experience such a world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Earth is a silly little blue planet where people eat pies made with tomatoes and cheese.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s called pizza,” Grandma Wrinkle said. “And I hear it’s delicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Earthlings are empty-headed. I hear they wiggle their bottom halves to the sound of beating drums.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("“That’s called dancing,” Grandma Wrinkle said. “They say it’s fun. A word you have forgotten the meaning of.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Earth is a trivial place. We will find your grandson there and bring him home. Once we deactivate his sensory enhancer, he will never experience joy again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You won’t find him,” Grandma Wrinkle said. “There are over seven billion people on Earth. And I have given him a secret identity. He looks just like any other earthling.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Supreme Leader rose to his feet, and he used the voice activator attached to his neck to fill the room with sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will tell us where he is,” he roared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will not,” Grandma Wrinkle said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I command you!” His voice rose to an ear-splitting level. The small bones inside Grandma Wrinkle’s inner ear vibrated so hard they snapped in two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never!” she shouted back, clutching her ears from the searing pain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All you have to do is answer one simple question,” the Supreme Leader roared. “Where on Earth is your grandson, Citizen Short Nose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandma Wrinkle made the sign of the zipper, as if she were zipping her lips closed forever. She had seen Earth children do that in the movies she secretly watched with her grandson in the cave beneath her house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("“You leave me no choice,” the Supreme Leader said, “but to turn you over to Citizen Cruel. She will get the information out of you. Citizen Cruel, are you up for the task?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. But it will require physical endurance because she’ll be a tough one to crack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go to the Power Pole,” he commanded. “I will administer a Super Strength Blast.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Citizen Cruel walked to a thick metal pole that was connected to a power generator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hold the pole,” the Supreme Leader ordered. “Citizen Bulk, flip the switch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A buzzing sound reverberated around the giant room. Citizen Cruel’s body became transparent, and all her organs were visible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s enough,” the Supreme Leader said. “Citizen Bulk, disengage the power!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The buzzing sound stopped and Citizen Cruel let go of the pole. Her body came back to normal and her red lips spread into a wicked smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I feel like I could fly without a vehicle,” she said. “Super strong, super powerful, super mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why I invented the Power Pole,” the Supreme Leader said. “Go forth and do your work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("He jumped back onto his platform and floated high into the air until he was just a spot at the top of the cavern.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find that traitor,” he shouted to Citizen Cruel, as he disappeared into the ceiling. “Use any means necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Citizen Cruel looked at Grandma Wrinkle, and a crooked smile crossed her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We will get the information out of you,” she said. “Citizen Bulk, bring me the Truth Serum, the one in the green vial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But we’ve never used that before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly.” Citizen Cruel smiled her wicked smile, her golden eyes aflame. “This is my date with destiny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, rubbing her hands together in anticipation of the pain she was about to cause, Citizen Cruel laughed so hard that the sound of chicken-bone choking filled the vast hall all the way up to the rafters.")]), _vm._v(" "), _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 66
// module chunks = 0